import * as React from 'react'
import { FaIcon, faDownloadSolid } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  selectedCount: number
  onDownload: () => void
  onClose: () => void
}

export const HistorySelectedActionBar: React.FC<Props> = ({
  selectedCount,
  onDownload,
  onClose,
}) => {
  const { t } = useLocalize()

  return (
    <div className="tw-relative tw-bg-content-primary">
      <div className="tw-relative tw-z-20 tw-flex tw-w-full tw-justify-between tw-border-b-2 tw-border-primary tw-bg-[#F1F4FF] tw-px-4 tw-py-3.5 lg:tw-items-center">
        <div className="tw-absolute -tw-bottom-1.5 tw-left-3">
          <div className="tw-absolute -tw-top-1.5 !tw-z-10 tw-h-2 tw-w-2 tw-bg-[#F1F4FF]"></div>
          <div className="tw-h-2 tw-w-2 tw-rotate-45 tw-bg-primary"></div>
        </div>

        <div className="tw-flex tw-flex-col tw-items-start tw-gap-5 lg:tw-flex-row lg:tw-items-center">
          <p className="tw-m-0 tw-space-x-1 tw-text-sm tw-text-[#1f2937]">
            <span className="tw-inline-block">{t('importModule.history-bar-actions-for')}</span>
            <span className="tw-font-medium">{selectedCount}.</span>
            <span>{t('importModule.history-bar-files')}</span>
          </p>
        </div>

        <div className="tw-flex tw-items-center tw-gap-4">
          <Tooltip text={t('importModule.history-download')} onClick={onDownload}>
            <div className="tw-flex tw-h-5 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 hover:tw-bg-[#e5e6e6]">
              <FaIcon icon={faDownloadSolid} className="tw-h-4 tw-w-4 tw-text-primary" />
              <span className="tw-text-sm tw-font-medium tw-text-primary">
                {t('importModule.history-download')}
              </span>
            </div>
          </Tooltip>

          <div className="tw-h-[18px] tw-w-px tw-bg-[#e5e6e6]"></div>

          <Tooltip text={t('common.close')} onClick={onClose}>
            <div className="tw-relative tw-cursor-pointer">
              <div className="tw-absolute -tw-top-1.5 tw-left-1/2 tw-z-0 tw-h-7 tw-w-7 tw--translate-x-1/2 tw-rounded-full tw-bg-white tw-p-2 tw-shadow lg:tw-top-1/2 lg:tw--translate-y-1/2"></div>
              <FaIcon icon={faClose} className="tw-relative" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
